import Vue from "vue";
import moment from "moment";

// export const userKey = '__seplag_user_storage_portal_Servidor_producao'
export const baseApiUrl = process.env.VUE_APP_API_URL;
export const baseApiUrlCertidao = process.env.VUE_APP_API_URL_CERTIDAO;
export const baseApiUrlCracha = process.env.VUE_APP_API_URL_CRACHA;
// URL Default de acesso ao sistema de recurso da aplicação
/* endereço da API no ambiente de DESENVOLVIMENTO */
// export const baseApiUrl = "http://localhost:8083"
/* endereço da API no ambiente de HOMOLOGAÇÃO */
// export const baseApiUrl = "http://homolog.servicos.seplag.mt.gov.br/apiportalservidor"
/* endereço da API no ambiente de PRODUÇÃO */
// export const baseApiUrl = "https://servicos.seplag.mt.gov.br/apiportalservidor"
/* endereço da API no ambiente de Homologação servicos */
// export const baseApiUrl = "http://servicoshomolog.seplag.mt.gov.br/apiportalservidor"

export const sexo = [
  { name: "Masculino", code: "M" },
  { name: "Feminino", code: "F" },
];

export const simNao = [
  { name: "Não", code: "N" },
  { name: "Sim", code: "S" },
];

export const perfis = [];

export const perfisAdm = [];

export const autorizacaoRota = [
  { perfil: "PORT_HOLERITE", rota: "holerite" },
  { perfil: "PORT_LICENCA_PREMIO", rota: "licencaPremioServidor" },
  { perfil: "PORT_DADOS_PESSOAIS", rota: "dadosPessoaisServidor" },
  { perfil: "PORT_RETRATO_FUNCIONAL", rota: "retratoFuncional" },
  {
    perfil: "PORT_CONTRIBUICAO_PREVIDENCIARIA",
    rota: "contribuicaoPrevidenciaria",
  },
  { perfil: "PORT_FERIAS", rota: "feriasServidor" },
  { perfil: "PORT_CEDULAC", rota: "cedulac" },
  { perfil: "PORT_ESCALA_ANUAL", rota: "escalaAnual" },
  { perfil: "PORT_VINCULO", rota: "vinculo" },
  { perfil: "PORT_LIBERACAO_FERIAS", rota: "liberacaoFerias" },
  { perfil: "PORT_CONTROLE_PERFIL_CHEFIA", rota: "controlePerfilChefia" },
  { perfil: "PORT_ESCALA_ANUAL_RH_FERIAS", rota: "escalaAnualRhFerias" },
  {
    perfil: "PORT_ESCALA_ANUAL_RH_LICENCA_PREMIO",
    rota: "escalaAnualRhLicencaPremio",
  },
  { perfil: "PORT_ESCALA_ANUAL_RH", rota: "cadEscala" },
  {
    perfil: "PORT_DATA_LIMITE_SOLI_AFASTAMENTO",
    rota: "datalimitesocilicitacaoafastamento",
  },
  { perfil: "PORT_ORGAO_VINCULADO", rota: "orgaoVinculado" },
  { perfil: "PORT_GERENCIA_RELATORIOS", rota: "gerenciaRelatorios" },
  { perfil: "PORT_GESTAO_FERIAS", rota: "gestaoferias" },
  { perfil: "PORT_CERTIDOES", rota: "certidoes" },
  { perfil: "PORT_FICHA_FINANCEIRA", rota: "fichafinanceira" },
  { perfil: "PORT_BOTAO_SGA", rota: "sga" },
  { perfil: "PORT_BOTAO_CAT", rota: "cat" },
  { perfil: "PORT_BOTAO_RECADASTRAMENTO", rota: "recadastramento" },
  { perfil: "PORT_BOTAO_TABELA_SALARIAL", rota: "tabelaSalarial" },
  { perfil: "PORT_BOTAO_DECLARACAO_BENS", rota: "declaracaobens" },
  { perfil: "PORT_BOTAO_CARTEIRA_FUNCIONAL", rota: "carteiraFuncional" },
  { perfil: "PORT_BOTAO_CRACHA", rota: "cracha" },
  { perfil: "PORT_BOTAO_CONSIGNADOS", rota: "consignado" },
  { perfil: "PORT_BOTAO_HOLERITE_PENSIONISTA", rota: "holeritePensionista" },
  { perfil: "PORT_MODAL_INFO_CONSIGNADOS", rota: "modalConsignado" },
  { perfil: "PORT_MT_PREVE", rota: "mtPrev" },
  {
    perfil: "PORT_FERIAS_CHEFIA_PENDENTE",
    rota: "feriasChefiaPendenteValidacao",
  },
  { perfil: "PORT_FERIAS_CHEFIA_VALIDADOS", rota: "feriasChefiaValidos" },
  {
    perfil: "PORT_FERIAS_CHEFIA_NAO_AGENDADO",
    rota: "feriasChefiaNaoAgendado",
  },
  {
    perfil: "PORT_FERIAS_CHEFIA_NAO_AGENDADO_AGENDA",
    rota: "feriasChefiaNaoAgendadoagenda",
  },
  { perfil: "PORT_LICENCA_CHEFIA_PENDENTE", rota: "ChefiaPendentesLicenca" },
  { perfil: "PORT_LICENCA_CHEFIA_VALIDADOS", rota: "ChefiaValidadosLicenca" },
  { perfil: "PORT_VERBA_IDENIZATORIA", rota: "solicitaVerba" },
  { perfil: "PORT_VERBA_IDENIZATORIA_ADMIN", rota: "solicitaVerbaAdmin" },
  { perfil: "PORT_VERBA_IDENIZATORIA_FORM", rota: "solicitaVerbaForm" },
  {
    perfil: "PORT_VERBA_IDENIZATORIA_VALIDACAO",
    rota: "solicitaVerbaValidaDespacho",
  },
  { perfil: "PORT_VERBA_IDENIZATORIA_DESPACHO", rota: "solicitaVerbaDespacho" },
  {
    perfil: "PORT_VERBA_IDENIZATORIA_LISTA_DESPACHO",
    rota: "solicitaVerbaProcurador",
  },
  { perfil: "PORT_VERBA_IDENIZATORIA_INDICE", rota: "indiceCalculo" },
  { perfil: "PORT_VERBA_IDENIZATORIA_PARAMETRO", rota: "parametroSolicitacao" },
  {
    perfil: "PORT_VERBA_IDENIZATORIA_DESPACHO_VIEW",
    rota: "solicitaVerbaDespachoView",
  },
  {
    perfil: "ROLE_PORT_VERBA_RESCISORIA_DESPACHO_GRAVAR",
    rota: "solicitaVerbaDespachoGravar",
  },
  {
    perfil: "ROLE_PORT_VERBA_RESCISORIA_DESPACHO_FINALIZAR",
    rota: "solicitaVerbaDespachoFinalizar",
  },
  {
    perfil: "ROLE_PORT_VERBA_RESCISORIA_REVERTER_SOLICITACAO",
    rota: "solicitaVerbaReverterSolicitacao",
  },
  { perfil: "PORT_ACESSO_DRE", rota: "manterDRE" },
  { perfil: "PORT_ACESSO_DRE", rota: "vincularEscolas" },
  { perfil: "PORT_ACESSO_CHEFE_DRE", rota: "vincularEscolas" },
  { perfil: "PORT_ACESSO_SETORIAL_RH", rota: "acessoSetorial" },
  { perfil: "PORT_ACESSO_CENTRAL_RH", rota: "acessoCentral" },
  { perfil: "PORT_ACESSO_CRONOGRAMA_FERIAS", rota: "cronogramaFerias" },
  { perfil: "PORT_GESTAO_LP",rota: "gestaoLicencaPremio" },
  { perfil: "PORT_ACESSO_CHEFIA_LICENCA_CARGO",rota: "gestaoLPComissionado" },
  { perfil: "ADM_BANCO_TALENTOS",rota: "admBancoTalentos" },
];

export function isUserTemPerssaoGlobal(nomeRota) {
  let LocalStorageSeplag = localStorage.getItem(process.env.VUE_APP_USER_KEY);
  let dadosStorageSeplagJson = null;
  if (LocalStorageSeplag) {
    dadosStorageSeplagJson = decodeURI(atob(LocalStorageSeplag));
  }
  let storageSeplagJson = JSON.parse(dadosStorageSeplagJson);
  let getUser = null;
  if (storageSeplagJson) {
    if (
      storageSeplagJson[process.env.VUE_APP_NOME_SISTEMA] &&
      storageSeplagJson[process.env.VUE_APP_NOME_SISTEMA].seguranca
    ) {
      getUser = storageSeplagJson[process.env.VUE_APP_NOME_SISTEMA].seguranca;
    }
  }
  if (getUser) {
    let autorizacao = autorizacaoRota.filter((element) => {
      return element.rota == nomeRota;
    });
    if (autorizacao.length > 0) {
      let listaAutorizacao = getUser.contaAcesso.authorities.filter(
        (element) => {
          return element.nomeRole == autorizacao[0].perfil;
        }
      );
      if (listaAutorizacao.length > 0) {
        return true;
      } else {
        let verifica = getUser.contaAcesso.direitosDinamicos.filter(function (
          element
        ) {
          return element.nomeRole == autorizacao[0].perfil;
        });
        if (verifica && verifica.length > 0) {
          return true;
        }
      }
    }
  }
  return false;
}

export function printToast({ severity, summary, detail = "" }) {
  let maiorMessage = summary.length > detail.length ? summary : detail;
  let messageLength = maiorMessage.split(" ").length;
  let life = (messageLength * 60000) / 150;
  Vue.prototype.$toast.add({ severity, summary, detail, life });
}

// Tratamento de erro geral das telas
Vue.config.errorHandler = function (err, vm, info) {
  // trata a mensagem para ser exibida ao usuário)
  exibirErroTratado(err, vm, "error", info);
};

export function exibirErroTratado(error, vm, severity, info) {
  // Cria as variavel de mensagem ao usuário
  let msgUsuario = "";
  // Verifica mensagem retornada
  if (error && error.response && error.response.data) {
    if (
      Array.isArray(error.response.data) &&
      error.response.data[0].msgUsuario
    ) {
      msgUsuario = error.response.data[0].msgUsuario;
    } else {
      msgUsuario = error.response.data;
    }
  } else if (typeof error === "string") {
    msgUsuario = error;
  } else {
    msgUsuario = info;
  }
  if (typeof msgUsuario != "object") {
    Vue.prototype.$toast.add({ severity, summary: msgUsuario, life: 15000 });
  }
}

Vue.config.warnHandler = function (msg, vm) {
  exibirErroTratado(
    msg,
    vm.parent,
    "warn",
    "Um alerta na operação do sistema foi gerado"
  );
};

export function languagePtBr() {
  return {
    firstDayOfWeek: 0,
    dayNames: [
      "Domingo",
      "Segunda",
      "Terça",
      "Quarta",
      "Quinta",
      "Sexta",
      "Sábado",
    ],
    dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
    dayNamesMin: ["Do", "Se", "Te", "Qa", "Qi", "Sx", "Sa"],
    monthNames: [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ],
    monthNamesShort: [
      "Jan",
      "Fev",
      "Mar",
      "Abr",
      "Mai",
      "Jun",
      "Jul",
      "Ago",
      "Set",
      "Out",
      "Nov",
      "Dez",
    ],
    today: "Hoje",
    clear: "Limpar",
    dateFormat: "dd/mm/yy",
    weekHeader: "Sm",
    months: [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ],
  };
}

export function isDate(data) {
  return data instanceof Date && !isNaN(data.valueOf());
}

export function strToDate(objeto, campos) {
  // Percorre a array de campos
  for (var i = 0; i < campos.length; i++) {
    // Verifcia se é a propriedade display format
    if (campos[i].displayFormat) {
      // carrega o objeto campo
      var campo = campos[i];
      // Converte a string para o formato data
      objeto[campo] = moment(objeto[campo], campo.displayFormat).toDate();
    }
  }
}

export function dateToStr(objeto, campos) {
  // Percorre a array de campos
  for (var i = 0; i < campos.length; i++) {
    // Verifcia se é a propriedade display format
    if (campos[i].displayFormat) {
      // carrega o objeto campo
      var campo = campos[i];
      // Converte a string para o formato data
      objeto[campo.nome] = moment(objeto[campo.nome]).format(
        campo.displayFormat
      );
    }
  }
}

export function detectaNavegador() {
  var isOpera = !!window.opera || navigator.userAgent.indexOf(" OPR/") >= 0;

  var isFirefox = typeof InstallTrigger !== "undefined";
  var isSafari =
    Object.prototype.toString.call(window.HTMLElement).indexOf("Constructor") >
    0;

  var isChrome = !!window.chrome && !isOpera;
  var isIE = /*@cc_on!@*/ false || !!document.documentMode;
  if (isOpera) {
    return 1;
  } else if (isFirefox) {
    return 2;
  } else if (isChrome) {
    return 3;
  } else if (isSafari) {
    return 4;
  } else if (isIE) {
    return 5;
  } else {
    return 0;
  }
}

export default {
  baseApiUrl,
  sexo,
  simNao,
  perfis,
  perfisAdm,
  languagePtBr,
  isDate,
  strToDate,
  dateToStr,
  exibirErroTratado,
  printToast,
  isUserTemPerssaoGlobal,
};
